import React, { Component } from 'react';
import { connect } from 'react-redux';
import { popupDispatcher, identityState } from '../../store';
import { PropTypes } from 'prop-types';
import { translate } from '../../services';
import { IconButton, ImportCartPanel } from '..';
import { uploadIcon } from '../../../style/images';

export class EmptyCartComponent extends Component {
  openImport = () => {
    this.props.setPopup( { title: 'Import Cart', component: <ImportCartPanel />, showHeader: true, keepOpen: false } );
  }

  render() {
    const {user} = this.props
    const isCbolCall = user && user.authenticationType === 'Cbol';
    return <div className="empty-cart">
      <h1>{ translate( 'Your cart is Empty' ) }</h1>
      <span>{ translate( 'Add products or import a cart.' ) }</span>
      { !isCbolCall && <IconButton className="blue-button" icon={ uploadIcon } text={ translate( 'Import cart' ) } onClick={ this.openImport }/> }
    </div>;
  }
}

EmptyCartComponent.propTypes = {
  setPopup: PropTypes.func.isRequired,
};

export const EmptyCart = connect( identityState, popupDispatcher )( EmptyCartComponent );